export default __webpack_public_path__ + "static/media/cocktail.d3b3fdb2.png";